export const roomFacilitesColumns = [
    {
        Header: 'Facilites Id',
        accessor: 'facilitesId',
    },
    {
        Header: 'Facilites Name',
        accessor: 'facilitesName',
    },
    {
        Header: 'Actions',
        accessor: 'actions',
    }
]

export const roomFacilitesData = [
    {
        facilitesId: '1101',
        facilitesName:'Delicious Food',
    },
    {
        facilitesId: '1102',
        facilitesName:'Cozy beds',
    },
    {
        facilitesId: '1103',
        facilitesName:'Wifi',
    },
    {
        facilitesId: '1104',
        facilitesName:'Locker',
    },
    {
        facilitesId: '1105',
        facilitesName:'Aroma',
    },
    {
        facilitesId: '1106',
        facilitesName:'Cleanliness',
    },
]